module.exports = __webpack_public_path__ + "img/chijieban1.bca7d852.jpg";